module.exports = __webpack_public_path__ + "img/egy.6b83ab95.svg";